<template>
  <v-modal
    :is-open="showModal"
    :show-close-button="false"
    data-test="personal-information-cpr-consent-modal"
  >
    <template #title>
      <div>
        <h2
          data-test="personal-information-cpr-consent-modal-headline"
          class="center"
          v-html="headline"
        />
      </div>
    </template>
    <template #content>
      <div>
        <h3 data-test="personal-information-cpr-consent-modal-heading" v-html="heading" />
        <p data-test="personal-information-cpr-consent-modal-description" v-html="description" />
      </div>
    </template>
    <template #buttons>
      <button
        class="button large"
        data-test="personal-information-cpr-consent-modal-close-button"
        @click="closeModal"
        v-html="buttonLabel"
      />
    </template>
  </v-modal>
</template>
<script>
import { mapState } from 'vuex';
import vModal from '@/components/UI/Modal.vue';

export default {
  name: 'CprConsentModal',

  props: {
    modelValue: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  computed: {
    ...mapState({
      headline: (state) =>
        state.createMember.vueModel.stepOnePersonalInformation.modalCPRConsentHeadline,
      heading: (state) =>
        state.createMember.vueModel.stepOnePersonalInformation.modalCPRConsentHeading,
      description: (state) =>
        state.createMember.vueModel.stepOnePersonalInformation.modalCPRConsentDescription,
      buttonLabel: (state) =>
        state.createMember.vueModel.stepOnePersonalInformation.modalCPRConsentButtonLabel
    }),
    showModal: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit('update:modelValue', val);
      }
    }
  },
  methods: {
    closeModal() {
      this.showModal = false;
    }
  }
};
</script>
<style scoped>
h2.center {
  text-align: center;
}
</style>
